var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSg = function SvgSg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.333 0h48v32h-48V0z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.333 0h48v16h-48V0z",
    fill: "#DF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.737 2.682c-2.216.508-3.863 2.15-4.33 4.38-.632 3.03 1.343 6 4.38 6.633-3.07.875-6.24-.89-7.106-3.93s.898-6.21 3.94-7.076c1.066-.305 2.05-.307 3.117-.007z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.865 7.33l.326 1.008-.86-.615-.86.62.32-1.01-.856-.623 1.058-.01.33-1.006.334 1.005h1.06zM10.036 10.8l.326 1.01-.862-.616-.858.62.32-1.01-.857-.623 1.058-.008.33-1.007.334 1.005 1.06.002zM13.93 10.776l.327 1.008-.862-.615-.858.62.32-1.01-.857-.624 1.058-.01.33-1.006.334 1.005 1.06.002zM15.093 7.333l.326 1.008-.863-.614-.858.62.318-1.01-.856-.623 1.058-.01.33-1.006.334 1.005 1.06.002zM12.01 5.05l.325 1.008-.862-.615-.858.62.32-1.01-.857-.623 1.058-.01.33-1.006.334 1.005h1.06z",
    fill: "#FFF"
  })));
};
export default SvgSg;